import * as React from "react";
import {
  Label,
  Input,
  Caption1,
} from "@fluentui/react-components";
import {
  Cloud24Regular,
  Key24Regular
} from "@fluentui/react-icons";
import { ServiceType } from "../../../../contexts/SettingsContext";

interface ApiConfigurationProps {
  apiKeyLabel: string;
  apiKeyPlaceholder: string;
  apiKeyDescription: string;
  apiKey: string;
  onApiKeyChange: (apiKey: string) => void;
  
  apiUrlLabel: string;
  apiUrlPlaceholder: string;
  apiUrlDescription: string;
  apiUrl: string;
  onApiUrlChange: (apiUrl: string) => void;
  
  selectedService: ServiceType;
}

const servicesRequiringUrl: ServiceType[] = [
  'azure',
  'openai-compatible',
  'bedrock',
  'bedrock-agentcore'
];

const urlDescriptions: Partial<Record<ServiceType, string>> = {
  'azure': 'Your Azure OpenAI resource endpoint URL',
  'openai-compatible': 'Custom API endpoint for OpenAI compatible services',
  'bedrock': 'Bedrock Mantle endpoint URL for your AWS region',
  'bedrock-agentcore': 'Your AgentCore Runtime agent endpoint URL (agent ARN)'
};

const urlPlaceholders: Partial<Record<ServiceType, string>> = {
  'azure': 'https://your-resource.openai.azure.com',
  'openai-compatible': 'https://your-provider.com/v1',
  'bedrock': 'https://bedrock-mantle.us-east-1.api.aws',
  'bedrock-agentcore': 'Enter your AgentCore agent endpoint URL'
};

const ApiConfiguration: React.FC<ApiConfigurationProps> = ({
  apiKeyLabel,
  apiKeyPlaceholder,
  apiKeyDescription,
  apiKey,
  onApiKeyChange,
  
  apiUrlLabel,
  apiUrlPlaceholder,
  apiUrlDescription,
  apiUrl,
  onApiUrlChange,
  
  selectedService,
}) => {
  const showUrl = servicesRequiringUrl.includes(selectedService);
  const effectiveUrlDescription = urlDescriptions[selectedService] || apiUrlDescription;
  const effectiveUrlPlaceholder = urlPlaceholders[selectedService] || apiUrlPlaceholder;

  return (
    <div>
      {/* API Key Input */}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "20px" }}>
        <Label htmlFor="apiKey">{apiKeyLabel}</Label>
        <Input
          id="apiKey"
          type="password"
          value={apiKey}
          onChange={(_, data) => onApiKeyChange(data.value)}
          placeholder={apiKeyPlaceholder}
          contentBefore={<Key24Regular />}
        />
        <Caption1>
          {apiKeyDescription}
        </Caption1>
      </div>

      {/* API URL Input - Only show for providers that require a custom URL */}
      {showUrl && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "12px" }}>
          <Label htmlFor="apiUrl">{apiUrlLabel}</Label>
          <Input
            id="apiUrl"
            value={apiUrl}
            onChange={(_, data) => onApiUrlChange(data.value)}
            placeholder={effectiveUrlPlaceholder}
            contentBefore={<Cloud24Regular />}
          />
          <Caption1>
            {effectiveUrlDescription}
          </Caption1>
        </div>
      )}
    </div>
  );
};

export default ApiConfiguration;